import { APIConfigSet } from '../../dao-generator';
/**
 * 租户空间操作接口
 */
const spaceOperateModule: APIConfigSet = {
  // 列出租户空间
  getSpaceList: {
    method: 'get',
    path: '/api/v1/space/{libraryId}',
    queryKeys: { required: ['accessToken', 'user_id'] },
    autoParams: {
      libraryId: '',
      accessToken: '',
      user_id: '',
    },
  },
  // 查询租户空间属性
  getSpaceConfig: {
    method: 'get',
    path: '/api/v1/space/{libraryId}/{spaceId}/extension',
    queryKeys: { required: ['access_token', 'user_id'] },
    autoParams: {
      libraryId: '',
      spaceId: '',
      access_token: '',
      user_id: '',
    },
  },
  // 查询租户空间大小
  getSpaceSize: {
    method: 'get',
    path: '/api/v1/space/{libraryId}/{spaceId}/size',
    queryKeys: { required: ['access_token', 'user_id'] },
    autoParams: {
      libraryId: '',
      spaceId: '',
      access_token: '',
      user_id: '',
    },
  },
  // 创建租户空间
  createSpace: {
    method: 'post',
    path: '/api/v1/space/{libraryId}',
    queryKeys: { required: ['access_token', 'user_id'] },
    bodyKeys: {
      required: ['spaceTag'],
      noRequired: [
        'isPublicRead',
        'isMultiAlbum',
        'allowPhoto',
        'allowVideo',
        'allowPhotoExtname',
        'allowVideoExtname',
        'recognizeSensitiveContent',
      ],
    },
    autoParams: {
      libraryId: '',
      access_token: '',
      user_id: '',
    },
  },
  // 修改租户空间属性
  updateSpace: {
    method: 'post',
    path: '/api/v1/space/{libraryId}/{spaceId}/extension',
    queryKeys: { required: ['access_token', 'user_id'] },
    bodyKeys: {
      noRequired: [
        'isPublicRead',
        'allowPhoto',
        'allowVideo',
        'allowPhotoExtname',
        'allowVideoExtname',
        'recognizeSensitiveContent',
      ],
    },
    autoParams: {
      libraryId: '',
      spaceId: '',
      access_token: '',
      user_id: '',
    },
  },
  // 删除租户空间
  deleteSpace: {
    method: 'delete',
    path: '/api/v1/space/{libraryId}/{spaceId}',
    queryKeys: { required: ['access_token', 'user_id'] },
    autoParams: {
      libraryId: '',
      spaceId: '',
      access_token: '',
      user_id: '',
    },
  },
};

/*
 * 访问令牌操作接口
 */
const accessTokenModule: APIConfigSet = {
  // 访问令牌续期
  renewAccessToken: {
    method: 'post',
    path: '/api/v1/token/{libraryId}/{accessToken}',
    queryKeys: { required: ['access_token'] },
    autoParams: {
      libraryId: '',
      accessToken: '',
    },
  },
  // 删除指定的访问令牌
  deleteAccessToken: {
    method: 'delete',
    path: '/api/v1/token/{libraryId}/{accessToken}',
    autoParams: {
      libraryId: '',
      accessToken: '',
    },
  },
};

// 目录或相簿操作接口
const directoryOperateModule: APIConfigSet = {
  // 列出目录或相簿内容
  listDirectory: {
    method: 'get',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    queryKeys: {
      required: ['access_token'],
      noRequired: [
        'page',
        'page_size', // page 和 page_size必须同时传，否则 page 会失效
        'order_by',
        'order_by_type',
        'filter',
        'sort_type',
        'space_org_id',
        'marker',
        'limit',
      ],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { dirPath: '' },
  },
  // 查看目录或相簿详情
  getDirectoryInfo: {
    method: 'get',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    actionKey: 'info',
    queryKeys: {
      required: ['access_token'],
      noRequired: ['purpose'],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { dirPath: '' },
  },
  // 检查目录或相簿状态
  inspectDirectory: {
    method: 'head',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    queryKeys: { required: ['access_token', 'user_id'], noRequired: ['syncId'] },
    autoParams: {
      libraryId: '',
      spaceId: '',
      access_token: '',
      user_id: '',
    },
    defaultParams: { dirPath: '' },
  },
  // 创建目录或相簿
  createDirectory: {
    method: 'put',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    queryKeys: {
      required: ['access_token', 'user_id'],
      noRequired: ['conflict_resolution_strategy'],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { conflict_resolution_strategy: 'ask' },
  },
  // 删除目录或相簿
  deleteDirectory: {
    method: 'delete',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    queryKeys: { required: ['access_token', 'permanent'], noRequired: ['space_org_id'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { permanent: 0 },
  },
  // 重命名或移动目录或相簿
  renameOrMoveDirectory: {
    method: 'put',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    queryKeys: {
      required: ['access_token'],
      noRequired: ['conflict_resolution_strategy', 'space_org_id', 'move_authority'],
    },
    bodyKeys: { required: ['from'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { conflict_resolution_strategy: 'ask' },
  },
  // 复制目录或相簿
  copyDirectory: {
    method: 'put',
    path: '/api/v1/directory/{libraryId}/{spaceId}/{dirPath}',
    queryKeys: {
      required: ['access_token'],
      noRequired: ['conflict_resolution_strategy'],
    },
    bodyKeys: { required: ['copyFrom'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { conflict_resolution_strategy: 'ask' },
  },
  // 创建标签
  createTags: {
    method: 'put',
    path: '/api/v1/tag/{libraryId}',
    queryKeys: { required: ['access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', access_token: '' },
    defaultParams: { tagType: 0 },
  },
  // 创建标签
  setFileTags: {
    method: 'put',
    path: '/api/v1/file-tag/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
};

/**
 * 文件操作接口
 */
const fileOperateModule: APIConfigSet = {
  // 检查目录或相簿状态
  inspectFile: {
    method: 'head',
    path: '/api/v1/file/{libraryId}/{spaceId}/{path}',
    queryKeys: { required: ['access_token', 'user_id'], noRequired: ['syncId'] },
    autoParams: {
      spaceId: '',
      libraryId: '',
      access_token: '',
      user_id: '',
    },
    defaultParams: { path: '' },
  },
  // 获取文件信息(不包含cosUrl，不计下载次数)
  getDownloadFileInfo: {
    method: 'get',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    actionKey: 'info',
    queryKeys: {
      required: ['access_token', 'user_id'],
      noRequired: [
        'history_id',
        'content_disposition',
        'watermark_text',
        'purpose',
        'space_org_id',
        'preview',
        'share_previewer_organization_id',
        'docPreviewMode',
        'pre_check',
      ],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', content_disposition: 'inline', pre_check: true },
  },
  // 获取文件cosUrl(调用一次，记一次下载)
  getDownloadCosUrl: {
    method: 'get',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    actionKey: 'info',
    queryKeys: {
      required: ['access_token', 'user_id'],
      noRequired: [
        'history_id',
        'content_disposition',
        'purpose',
        'space_org_id',
        'preview',
        'share_previewer_organization_id',
        'docPreviewMode',
        'domainTag',
        'height_size',
        'width_size',
      ],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', content_disposition: 'inline' },
  },
  // 检查文件上传的空间大小
  checkFileStorage: {
    method: 'get',
    path: '/api/v1/space/{libraryId}/{spaceId}/check-available-size',
    queryKeys: { required: ['access_token', 'user_id', 'size'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
  },
  // 开始简单上传文件
  uploadFile: {
    method: 'put',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: {
      required: ['access_token', 'user_id'],
      noRequired: ['conflict_resolution_strategy', 'filesize', 'syncId'],
    },
    bodyKeys: { noRequired: ['fullHash', 'beginningHash', 'size'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', conflict_resolution_strategy: 'rename' },
  },
  // 开始分块上传文件
  uploadMultiPartFile: {
    method: 'post',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    actionKey: 'multipart',
    queryKeys: {
      required: ['access_token', 'user_id'],
      noRequired: ['conflict_resolution_strategy', 'filesize', 'syncId'],
    },
    bodyKeys: { noRequired: ['partNumberRange'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', conflict_resolution_strategy: 'rename' },
  },
  // 分块上传任务续期
  updateMultiPartFileInfo: {
    method: 'post',
    path: '/api/v1/file/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'renew',
    queryKeys: { required: ['access_token', 'user_id'], noRequired: ['syncId'] },
    bodyKeys: { noRequired: ['partNumberRange'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { confirmKey: '' },
  },
  // 完成上传文件
  confirmUploadFile: {
    method: 'post',
    path: '/api/v1/file/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'confirm',
    queryKeys: {
      required: ['access_token', 'user_id'],
      noRequired: ['conflict_resolution_strategy', 'syncId'],
    },
    bodyKeys: { noRequired: ['crc64'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { confirmKey: '' },
  },
  // 获取文件上传任务状态
  getFileUploadStatus: {
    method: 'get',
    path: '/api/v1/file/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'upload',
    queryKeys: { required: ['access_token', 'user_id'], noRequired: ['syncId', 'no_upload_part_info'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { confirmKey: '' },
  },
  // 取消上传任务
  cancelFileUpload: {
    method: 'delete',
    path: '/api/v1/file/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'upload',
    queryKeys: { required: ['access_token', 'user_id'], noRequired: ['syncId'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { confirmKey: '' },
  },
  // 用模板创建文档
  createDoc: {
    method: 'put',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token'] },
    bodyKeys: { required: ['fromTemplate'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
  },
  createStencilFile: {
    method: 'put',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token'] },
    bodyKeys: { required: ['templateIds'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
  },
  // 删除文件
  deleteFile: {
    method: 'delete',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token', 'permanent'], noRequired: ['space_org_id'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', permanent: 0 },
  },
  // 重命名或移动文件
  renameOrMoveFile: {
    method: 'put',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token', 'conflict_resolution_strategy'], noRequired: ['space_org_id'] },
    bodyKeys: { required: ['from'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', conflict_resolution_strategy: 'rename' },
  },
  // 复制文件
  copyFile: {
    method: 'put',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token', 'conflict_resolution_strategy'] },
    bodyKeys: { required: ['copyFrom'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '', conflict_resolution_strategy: 'ask' },
  },
  // 批量重命名/移动
  batchMoveOrRename: {
    method: 'post',
    path: '/api/v1/batch/{libraryId}/{spaceId}',
    actionKey: 'move',
    queryKeys: { required: ['access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
  },
  // 预览文件
  checkPreviewAndDownloadTime: {
    method: 'get',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    actionKey: 'preview',
    queryKeys: {
      required: ['access_token', 'user_id', 'check_preview_and_download_times', 'space_org_id'],
      noRequired: ['history_id'],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    defaultParams: { filePath: '' },
  },
  // 获取编辑文件的信息（主要用于判断编辑是否有报错时使用）
  checkEditFile: {
    method: 'get',
    path: '/api/v1/office/{libraryId}/{spaceId}/edit/{filePath}',
    actionKey: 'preflight',
    queryKeys: { required: ['access_token'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { filePath: '' },
  },
  // 批量删除
  batchDelete: {
    method: 'post',
    path: '/api/v1/batch/{libraryId}/{spaceId}',
    actionKey: 'delete',
    queryKeys: { required: ['access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
  },
  // 批量复制
  batchCopy: {
    method: 'post',
    path: '/api/v1/batch/{libraryId}/{spaceId}',
    actionKey: 'copy',
    queryKeys: { required: ['access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
  },
  // 批量复制(保存到网盘)
  saveToCloudDisk: {
    method: 'post',
    path: '/api/v1/batch/{libraryId}/{spaceId}',
    actionKey: 'copy',
    queryKeys: { required: ['user_id'], noRequired: ['access_token', 'share_access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', accessToken: '', spaceId: '', userId: '' },
  },
  // 通library跨空间复制目录
  crossSpaceCopyDirectory: {
    method: 'put',
    path: '/api/v1/cross-space/directory/{libraryId}/{spaceId}/copy/{dirPath}',
    queryKeys: { required: ['access_token', 'conflict_resolution_strategy', 'user_id'] },
    bodyKeys: { required: ['copyFrom', 'copyFromSpaceId'] },
    autoParams: { libraryId: '', accessToken: '', spaceId: '', userId: '' },
    defaultParams: { conflict_resolution_strategy: 'rename' },
  },
  // 批量下载文件
  batchDownload: {
    method: 'post',
    path: '/api/v1/batch/{libraryId}/{spaceId}',
    actionKey: 'download',
    queryKeys: { required: ['access_token'], noRequired: ['share_previewer_organization_id', 'user_id'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', accessToken: '', spaceId: '', userId: '' },
  },
};

/*
 * 查询任务接口
 */
const taskModule: APIConfigSet = {
  // 批量操作异步任务查询 （只能查询 common.api 接口创建的异步任务）
  asyncTaskQuery: {
    method: 'get',
    path: '/api/v1/task/{libraryId}/{spaceId}/{taskIdList}',
    queryKeys: { required: ['access_token'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
};

/**
 * 共享授权接口
 */
const authModule: APIConfigSet = {
  // 为文件夹分配权限
  postDirPermission: {
    method: 'post',
    path: '/api/v1/authority/{libraryId}/{spaceId}/authorize/{dirPath}',
    queryKeys: { required: ['access_token'] },
    bodyKeys: { required: ['authorizeTo'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
  // 删除文件夹的权限
  deleteDirPermissions: {
    method: 'post',
    path: '/api/v1/authority/{libraryId}/{spaceId}/authorize/{dirPath}',
    actionKey: 'delete',
    queryKeys: { required: ['access_token'] },
    bodyKeys: { required: ['authorizeTo'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
};

/**
 * 文件共享接口
 */
const shareModule: APIConfigSet = {
  // 获取我共享的文件夹
  getSendShareDirectory: {
    method: 'get',
    path: '/api/v1/authority/{libraryId}/authorized-directory',
    queryKeys: {
      required: ['access_token', 'page', 'page_size'],
      noRequired: ['order_by', 'order_by_type'],
    },
    autoParams: { libraryId: '', access_token: '' },
  },
};
/**
 * 文件收集接口
 */
const collectModule: APIConfigSet = {
  // 获取访客（or内部成员）的记录
  getVisitorCollectHistory: {
    method: 'get',
    path: '/api/v1/collect/submit-history/{collectToken}',
    queryKeys: { required: ['access_token'] },
    autoParams: { access_token: '' },
  },
  // 规则保存
  saveCollectRule: {
    method: 'put',
    path: '/api/v1/collect/rules-history/{collectToken}',
    queryKeys: { required: ['access_token'] },
    bodyKeys: { required: ['rules'] },
    autoParams: { access_token: '' },
  },
  // 规则查询
  getCollectRule: {
    method: 'get',
    path: '/api/v1/collect/rules-history/{collectToken}',
    queryKeys: { required: ['access_token'] },
    autoParams: { access_token: '' },
  },
};

/**
 * 历史版本接口
 */
const historyVersionModule: APIConfigSet = {
  // 设置历史版本为最新版本
  setLatestVersion: {
    method: 'post',
    path: '/api/v1/directory-history/{libraryId}/{spaceId}/latest-version/{historyId}',
    queryKeys: { required: ['access_token'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
  // 删除历史版本
  deleteHistory: {
    method: 'post',
    path: '/api/v1/directory-history/{libraryId}/{spaceId}/delete',
    queryKeys: { required: ['access_token'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
};

/**
 * 文件同步操作接口
 */
// const fileSyncOperateModule: APIConfigSet = {
//   // 创建本地盘同步任务
//   createSync: {
//     method: 'put',
//     path: '/api/v1/directory-local-sync/{libraryId}/{spaceId}',
//     queryKeys: { required: ['access_token', 'user_id', 'spaceId'] },
//     bodyKeys: { required: ['path', 'strategy', 'localPath'] },
//     autoParams: { libraryId: '', access_token: '', user_id: '', spaceId: '' },
//   },
//   // 查询本地盘同步任务
//   getSyncInfo: {
//     method: 'get',
//     path: '/api/v1/directory-local-sync/{libraryId}/{spaceId}/{syncId}',
//     queryKeys: { required: ['access_token', 'user_id', 'spaceId', 'syncId'] },
//     autoParams: { libraryId: '', access_token: '', user_id: '', spaceId: '' },
//   },
//   // 删除本地盘同步任务
//   deleteSync: {
//     method: 'delete',
//     path: '/api/v1/directory-local-sync/{libraryId}/{spaceId}/{syncId}',
//     queryKeys: { required: ['access_token', 'user_id', 'spaceId'], noRequired: ['syncId'] },
//     autoParams: { libraryId: '', access_token: '', user_id: '', spaceId: '' },
//   },
// };

const electronicSignModule: APIConfigSet = {
  // 根据电子签模板生成文件（同【用模板创建文件接口】）
  getFileByTemplateId: {
    method: 'put',
    path: '/api/v1/file/{libraryId}/{spaceId}/{filePath}',
    queryKeys: { required: ['access_token', 'user_id', 'spaceId', 'filePath'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '', user_id: '' },
    bodyKeys: { required: ['fromTemplate'] },
  },
};

/**
 * 文件模板库操作接口
 */
const fileStencilModule: APIConfigSet = {
  // 获取模板库类型
  getStencilType: {
    method: 'get',
    path: '/api/v1/file-template/{libraryId}/template-type',
    queryKeys: { required: ['access_token'] },
    autoParams: { libraryId: '', access_token: '' },
  },
  // 获取模板库列表
  getStencilList: {
    method: 'get',
    path: '/api/v1/file-template/{libraryId}/list',
    queryKeys: {
      required: ['access_token', 'flag'],
      noRequired: ['template_type', 'marker', 'limit', 'file_type', 'template_name'],
    },
    autoParams: { libraryId: '', access_token: '' },
  },
};

const commonRequestItemSet: APIConfigSet = {
  ...spaceOperateModule,
  ...accessTokenModule,
  ...directoryOperateModule,
  ...fileOperateModule,
  // ...fileSyncOperateModule,
  ...historyVersionModule,
  ...shareModule,
  ...collectModule,
  ...authModule,
  ...taskModule,
  ...electronicSignModule,
  ...fileStencilModule,
};

export default commonRequestItemSet;
